import {GridLocaleText} from "@material-ui/data-grid";

export const tableLocalizations: Partial<GridLocaleText> = {
    toolbarDensity: 'Größe',
    toolbarDensityLabel: 'Größe',
    toolbarDensityCompact: 'Klein',
    toolbarDensityStandard: 'Mittel',
    toolbarDensityComfortable: 'Groß',
    toolbarColumns: "Spalten",
    toolbarColumnsLabel: "Spalten",
    toolbarFilters: "Filter",
    toolbarFiltersLabel: "Filter",
    filterValueTrue: "Aktiv",
    filterValueFalse: "Deaktiviert",
    filterValueAny: "Alle",
    filterOperatorIs: "ist gleich"
}